import { Injectable, inject } from '@angular/core';

import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly titleService = inject(Title);

  private currentTabTitle?: string;
  private customPageParent?: string;
  private customPageTitle?: string;

  public init(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        map((route) => route.snapshot),
        map((snapshot) => {
          while (snapshot) {
            if (snapshot.parent?.data.title !== this.customPageParent) {
              this.customPageParent = undefined;
              this.customPageTitle = undefined;
            }
            if (snapshot.paramMap.get('searchString') !== null) {
              return `${snapshot.paramMap.get('searchString')} | Search results`;
            } else if (snapshot.paramMap.get('id') !== null) {
              return `${snapshot.paramMap.get('id')}`;
            } else if (snapshot.data.title) {
              this.currentTabTitle = snapshot.data.title;
              if (snapshot.parent?.paramMap.get('id') !== null) {
                return `${
                  this.customPageTitle ? this.customPageTitle : snapshot.parent?.paramMap.get('id')
                } | ${snapshot.data.title}`;
              } else {
                return snapshot.data.title;
              }
            } else if (snapshot.parent) {
              snapshot = snapshot.parent;
            } else {
              return 'Unknown';
            }
          }
          return 'Unknown';
        }),
      )
      .subscribe((pathString) => this.titleService.setTitle(`${pathString}`));
  }

  public setTitle(title: string, setForAll?: string): void {
    // If setForAll is set, the title of all direct children of the page set to
    // will begin with the 'title' parameter until the user navigates away from them.
    if (setForAll) {
      this.customPageTitle = title;
      this.customPageParent = setForAll;
      title = `${title} | ${this.currentTabTitle}`;
    }
    this.titleService.setTitle(title);
  }
}
